const styles = (theme) => ({
  root: {
    fontFamily:theme.fontFamily.fontFamilyRegular,
  },
})

export default styles
